import { render, staticRenderFns } from "./brands.vue?vue&type=template&id=29ee5d34&"
import script from "./brands.vue?vue&type=script&lang=js&"
export * from "./brands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports